exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html,body,#app{padding:0;margin:0;box-sizing:border-box;font-size:16px;min-width:700px;background-color:#f3f7f9;color:#555;font-family:\"Roboto\",Arial,Helvetica,sans-serif}#tooltip{position:absolute;top:0;left:0}.customSelect__menu-portal{z-index:10 !important}", ""]);

